import { render, staticRenderFns } from "./RouterComponent.vue?vue&type=template&id=595dce5a"
import script from "./RouterComponent.vue?vue&type=script&lang=ts"
export * from "./RouterComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports